import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Profile from "./pages/profile";
import Home from "./pages/home";
import Login from "./pages/login";
import Register from "./pages/register";
import Reset from "./pages/reset";
import Recover from "./pages/recover";
import Dashboard from "./pages/dashboard";
import { useSelector } from "react-redux";
import Payment from "./pages/payment";
import UnsetProfile from "./pages/unsetProfile";
import Explore from "./pages/explore";
import ScrollToTop from "./utils/ScrollToTop";

const Router = () => {
  let isAuthenticated = useSelector((state: any) => state.auth.isAuthenticated);
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/login"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace={true} />
            ) : (
              <Login />
            )
          }
        />
        <Route
          path="/register"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace={true} />
            ) : (
              <Register />
            )
          }
        />
        <Route
          path="/recover"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace={true} />
            ) : (
              <Recover />
            )
          }
        />
        <Route path="/reset" element={<Reset />} />
        <Route
          path="/dashboard"
          element={
            isAuthenticated ? (
              <Dashboard />
            ) : (
              <Navigate to="/login" replace={true} />
            )
          }
        />
        <Route path="/payment" element={<Payment />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/unsetprofile" element={<UnsetProfile />} />
        <Route path="/:slug" element={<Profile />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
